import React from "react";
import PropTypes from "prop-types";
import { Box, Container } from "@material-ui/core";
import clsx from "classnames";

import { useStyles } from "../../hooks";
import styles from "./styles";

const Cover = ({ children, pathImage, gradient, rootMobile = false, root2 = false }) => {
  const classes = useStyles(styles, { pathImage });

  return (
    <Box
      className={clsx(rootMobile ? classes.rootMobile : root2 ? classes.root2 : classes.root, classes.imageContent, {
        [classes.gradient]: gradient
      })}
    >
      {
        children && (
          <Container className={classes.container}>{children}</Container>
        )
      }
    </Box>
  );
};

Cover.propTypes = {
  children: PropTypes.node,
  pathImage: PropTypes.string.isRequired,
  gradient: PropTypes.bool
};

export default Cover;
